import { Directive, inject, input } from '@angular/core';
import { DataAnalyticsTaggingEvent } from './data-analytics-tagging.domain';
import { DataAnalyticsTaggingConstants } from './data-analytics-tagging.constants';
import { DataAnalyticsTaggingService } from './data-analytics-tagging.service';

@Directive({
  selector: '[tdWbDataAnalyticsTaggingInput]',
  host: {
    '(click)': 'onClick($event)'
  }
})

export class DataAnalyticsTaggingInputDirective {
  private readonly dataAnalyticsTaggingService = inject(DataAnalyticsTaggingService);

  readonly dataAnalyticsTaggingEvent = input<DataAnalyticsTaggingEvent>(undefined, { alias: 'eventInput' });

  readonly sliderSection = input<string>(undefined);

  // For events whose property/attribute values are unknown until runtime
  // Only executes when Parent component set 'delayed' to 'false'

  onClick(event: Event): void {
    const target = event.target as HTMLElement | null;
    let targetIcon: HTMLElement = target?.querySelector('.td-wb-icon');
    if ((targetIcon == null)){
      targetIcon = target;
    }
    const iconEle: Attr = targetIcon.attributes.getNamedItem('iconid');
    const iconId = iconEle?.value;
    let eventName;
    const dataAnalyticsTaggingEvent = this.dataAnalyticsTaggingEvent();
    if (iconId){
      switch(iconId){
        case 'caret-left--small':
          eventName = `tdw:wbt:learn:${this.sliderSection()}:prev`;
          break;
        case 'caret-right--small':
          eventName = `tdw:wbt:learn:${this.sliderSection()}:next`;
          break;
        default:
          eventName = dataAnalyticsTaggingEvent.link?.name;
          break;
      }
    } else {
      eventName = dataAnalyticsTaggingEvent.link?.name;
    }
    if (eventName){
      if (dataAnalyticsTaggingEvent?.link?.type){
        this.dataAnalyticsTaggingService.emitTaggingEvent(DataAnalyticsTaggingConstants.getLinkClickEventData(eventName, dataAnalyticsTaggingEvent.link.type));
      } else {
        this.dataAnalyticsTaggingService.emitTaggingEvent(DataAnalyticsTaggingConstants.getLinkClickEventData(eventName));
      }
    }
  }
}
